import { useQuery } from '@tanstack/react-query'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchTeBeoordelen, initialState } from '../services/fetchTeBeoordelen'

import { useTeBeoordelenStore } from './useTeBeoordelenStore'

export { useTeBeoordelen, queryKey }

const queryKey = 'hoofdleiding-dashboard-tebeoordelen'

const useQueryStore = () => {
  const { query, storeQuery } = useTeBeoordelenStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useTeBeoordelen = () => {
  const { onChangeFilters, onReset, query } = useQueryStore()
  const { hasPermissions } = useAuthenticatedUser()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => fetchTeBeoordelen({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    initialFilters: initialState.query.filters,
    onChangeFilters,
    onReset,
    onRefresh: refetch,
  }
}
